import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import SEO from '../components/SEO';
import { siteInfo } from '../constants/siteInfo';

const ContactPage: React.FC = () => {
  return (
    <div className="font-body">
      <SEO 
        title="Contact"
        description="Contactez le Moulin Tala : adresse, téléphone, email, horaires et plan d'accès. Nous sommes situés à Brassy, au cœur du Morvan."
        canonicalUrl="https://lemoulintala.fr/contact"
        keywords="contact moulin tala, adresse moulin tala, téléphone moulin tala, horaire moulin tala, brassy morvan"
      />

      {/* Header */}
      <div className="bg-primary py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold text-white mb-4 font-heading">Contactez-Nous</h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Nous sommes à votre disposition pour répondre à toutes vos questions
          </p>
        </div>
      </div>

      {/* Contact Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold mb-8 text-primary text-center font-heading">Nos Coordonnées</h2>
            
            <div className="space-y-8">
              <div className="flex items-start bg-white p-6 rounded-lg shadow-sm text-darkGray">
                <div className="text-primary mt-1 mr-6">
                  <span><FaMapMarkerAlt size={28} /></span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-2 text-dark font-heading">Adresse</h3>
                  <p>62 Route du Moulin Tala</p>
                  <p>58140 BRASSY</p>
                  <p>France</p>
                </div>
              </div>
              
              <div className="flex items-start bg-white p-6 rounded-lg shadow-sm text-darkGray">
                <div className="text-primary mt-1 mr-6">
                  <span><FaPhone size={28} /></span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-2 text-dark font-heading">Téléphone</h3>
                  <p>03 86 22 22 61</p>
                  <p className="text-sm text-darkGray mt-1">Du mercredi au dimanche, 8h-18h</p>
                </div>
              </div>
              
              <div className="flex items-start bg-white p-6 rounded-lg shadow-sm text-darkGray">
                <div className="text-primary mt-1 mr-6">
                  <span><FaClock size={28} /></span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-2 text-dark font-heading">Horaires d'ouverture</h3>
                  <p className="font-medium text-dark">{siteInfo.seasonText}</p>
                  <ul className="mt-2 space-y-1">
                    <li>• Fermé le lundi et mardi</li>
                    <li>• Ouvert tous les jours du 14 juillet au dernier week-end d'août ainsi que les jours feriés</li>
                  </ul>
                  <p className="font-medium mt-3 text-dark">Restaurant :</p>
                  <p>Du mercredi au dimanche, 12h-14h uniquement</p>
                  <p className="font-medium mt-2 text-dark">Étangs de pêche :</p>
                  <p>Du mercredi au dimanche, 8h - 18h</p>
                </div>
              </div>
            </div>
            
            {/* Map */}
            <div className="mt-10 rounded-lg overflow-hidden shadow-md h-96 bg-gray">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d43437.91242599815!2d3.9276123934265455!3d47.27815312243054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f173df7b4e6aab%3A0x8ae66c6fac950249!2s58140%20Brassy!5e0!3m2!1sfr!2sfr!4v1711545845562!5m2!1sfr!2sfr" 
                width="100%" 
                height="100%" 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Moulin Tala - Brassy, Morvan"
                className="w-full h-full border-0"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* How to Find Us */}
      <section className="py-16 bg-light text-darkGray">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-8 text-primary text-center font-heading">Comment Nous Trouver</h2>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-lg mb-2 text-dark font-heading">Depuis Paris (3h)</h3>
                  <p>Prendre l'A6 direction Lyon, sortie 22 vers Avallon. Suivre la D957 puis la D42 direction Lormes. À Brassy, suivre les panneaux "Moulin Tala".</p>
                </div>
                
                <div>
                  <h3 className="font-semibold text-lg mb-2 text-dark font-heading">Depuis Dijon (1h30)</h3>
                  <p>Prendre l'A38 puis la D977bis direction Saulieu. Continuer sur la D17 vers Montsauche-les-Settons, puis la D501 vers Brassy.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage; 